import ThumbnailFactory from './ThumbnailFactory';
import Class from '@core/Class';
import Module from '@core/Module';
import View from '@core/View';
import assign from 'object-assign';
import PinchZoom from 'pinch-zoom-js';
import $ from '@modules/jquery-import';

/**
 * Parse data-attributes on el to apply configurations from, once attributes retrieved
 * will check if configuration has changed, if so fire event to re-initialize module
 * @param  {DOMNode} el       wrapper node for Module
 * @param  {Object} defaults  default configuration
 * @return {undefined}
 */
function apply_inline_configurations ( el, defaults ) {
    var conf = {};
    for ( var prop in defaults ) {
        // if nested object recurse
        if ( $.isObject( defaults[prop] ) ) {
            apply_inline_configurations( el, defaults[prop] )
        }
        //console.log(prop.replace('_','-'));
        var data = el[0].getAttribute( 'data-' + prop.replace( '_', '-' ) );
        if ( data && (data != undefined || data !== '') ) {
            conf[prop] = data;
        }
    }

    assign( defaults, conf );
    // fire event to re-initialize Module
}

const PhotoGallery = (Class.extend( Module )).extend( {

    elements: {
        '.upi-photo-preview': 'previewer',
        '.upi-photo-preview-zoom': 'previewerZoom',
        '.photo-gallery-controller': 'controls',
        '.photo-gallery-controller .prev': 'control_previous',
        '.photo-gallery-controller .next': 'control_next'
    },

    events: {
        'touchstart previewer': 'handleSwipe',
        'click control_previous': 'previous',
        'click control_next': 'next'
    },

    init: function ( el, config ) {
        var defaults = assign( {
            template: 'galleryImageViewer',
            collection: null,
            previewer_controls: false,
            control_placement: 'top',
            slide_controller: {
                type: 'slider',
                attributes: ['title', 'sku', 'image'],
                remote_query: null,
                slide_increment: 8
            }
        }, config || {} );

        // initialize slider controls for photo-gallery
        const ThumbnailController = ThumbnailFactory.create( defaults.slide_controller );
        this.thumb_control = new ThumbnailController( $( '<div />' ) );

        this.slider_control = this.thumb_control;
        this.collection = this.thumb_control.slide_collection;

        this.thumb_control.bind( 'change:slide', this.proxy( function ( e, data ) {
            this.change_image( data );
            this.current_index = this.collection.getIndex( data.id );
            this.toggle_forward_back_controls();
        } ) );

        this.thumb_control.bind( 'error:slide', this.proxy( function ( e, data ) {
            this.previewer.removeClass( 'loading' );
            this.trigger( 'error', data );
        } ) );

        // set initial defaults for photo-viewer
        this.current_index = 0;
        this.view = new View( defaults.template, this );

        if ( defaults.previewer_controls ) {
            this.previewer_controls_view = new View( 'gallerySlideController', this );
        }

        // binding has to be done once DOM is initialized
        this.ready( function () {
            this.previewer.addClass( 'loading' );
            this.el[(defaults.control_placement === 'bottom') ? 'append' : 'prepend']( this.thumb_control.el );

            if ( this.previewer_controls_view ) {
                this.previewer_controls_view.whenTemplatesLoaded.then( () => {
                    var tmpl = this.previewer_controls_view.render( {controller_type: 'photo-gallery-controller'} );
                    this.el.prepend( tmpl );
                    // add new items to element list
                    this.update_elements();
                    this.toggle_forward_back_controls();
                } );

                // if slide collection is stored as cached object initialize these controls
                // else collection will be created from remote_query from constructor
                if ( defaults.collection ) {
                    this.thumb_control.ready( this.proxy( function () {
                        this.collection.populate( defaults.collection );
                    } ) );

                    this.thumb_control.slide_collection.bind( 'error:loadremote', ( err ) => {
                        console.log( 'ERROR:', err.msg );
                    } )
                }

                // update view
            }
        } );

        return this;
    },

    handleSwipe: function ( e ) {
        const w = this.previewer.width();
        // enable swiping
        const touchStart = e.originalEvent.targetTouches[0];
        const threshold = 80;
        let x1 = touchStart.pageX;
        let y1 = touchStart.pageY;
        let x2 = 0;
        let y2 = 0;
        let deltaX = 0;
        let deltaY = 0;
        let left_pos = 0;
        let isScrolling = null;
        let offset = 0;

        this.previewer.on( 'touchmove', ( e ) => {
            const touchmove = e.originalEvent.touches[0];
            x2 = touchmove.pageX;
            y2 = touchmove.pageY;
            deltaX = x1 - x2;
            deltaY = y1 - y2;
            offset = (deltaX - (deltaX * .625)) / w;
            left_pos = -(offset) * 100;

            // is scrolling - ignore swipe
            if (
                isScrolling ||
                (Math.abs( deltaY ) > Math.abs( deltaX ) && Math.abs( deltaY ) > threshold)
            ) {
                isScrolling = true;
                return;
            }

            e.preventDefault();
            this.previewer.css( {marginLeft: left_pos + '%'} );
        } );

        //Touch Move
        this.previewer.on( 'touchend', ( e ) => {
            const exceeds_threshold = Math.abs( deltaX ) > threshold;
            if ( deltaX > 0 && exceeds_threshold ) {
                this.next();
            }
            else if ( deltaX < 0 && exceeds_threshold ) {
                this.previous();
            }

            // reset touch points
            x1 = x2 = deltaX = y1 = y2 = deltaY = 0;
            // reset preview position
            this.previewer.css( {marginLeft: '0%'} );
            this.previewer.off( 'touchmove touchend' );
        } );

    },

    change_image: function ( photo ) {
        var self = this,
            previewer = this.previewer,
            img = new Image();

        previewer.addClass( 'loading' );

        $( img ).on( 'load', function () {
            var tmpl = self.view.render( photo ),
                $photo = $( tmpl ).hide();

            previewer.html( $photo ).removeClass( 'loading' );

            $photo.show();
            const i = previewer.find( '.upi-photo-img' )[0];
            new PinchZoom( i, {
                tapZoomFactor: 2.5,
                draggableUnzoomed: false
            } );

        } );
        // preloaded image: once image is loaded apply to viewer from cache
        img.src = photo.image.source;
    },

    next: function () {
        var arr = this.collection.all(),
            item = arr[this.current_index + 1],
            item_id = (item) ? item.id : null;

        if ( item_id ) {
            this.thumb_control.change_slide( item_id );
        }
    },

    previous: function () {
        var arr = this.collection.all(),
            item = arr[this.current_index - 1],
            item_id = (item) ? item.id : null;

        if ( item_id ) {
            this.thumb_control.change_slide( item_id );
        }
    },

    toggle_forward_back_controls: function () {
        this.control_previous.removeClass( 'disabled' );
        this.control_next.removeClass( 'disabled' );

        if ( this.current_index === 0 ) {
            this.control_previous.addClass( 'disabled' );
        }
        if ( this.current_index >= (this.collection.all().length - 1) ) {
            this.control_next.addClass( 'disabled' );
        }
    }

} );

export default PhotoGallery;
